import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiAlertTriangle} = FiIcons;

const Footer = () => (
  <footer className="w-full px-4 md:px-6 py-5 mt-8 border-t border-slate-100 bg-white/50">
    <div className="max-w-[1600px] mx-auto">
      <div className="flex items-center gap-2 text-rose-500 mb-2">
        <SafeIcon icon={FiAlertTriangle} className="text-[10px]" />
        <h4 className="text-[9px] font-black uppercase tracking-widest">Legal Disclaimer & Strategic Disclosure</h4>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-6 text-[9px] leading-snug text-slate-500 font-medium">
        <p>
          WealthOS is a financial modeling and simulation platform designed for educational and informational purposes only.
          <strong className="text-slate-700"> The content, calculations, and projections provided herein do not constitute professional investment, tax, legal, or accounting advice.</strong>
          {' '}All projections are mathematical estimates based on user-provided inputs and historical market averages; they are not guarantees of future performance. Financial markets involve significant risk, and past performance is never indicative of future results.
        </p>
        <p>
          Before making any significant financial decisions, you should consult with a certified financial planner, licensed tax professional, or legal counsel.
          {' '}By using this tool, you acknowledge that you are responsible for your own financial research and decisions, and WealthOS shall not be held liable for any financial losses or damages resulting from the use of this modeling software.
        </p>
      </div>
      <p className="mt-3 pt-2 border-t border-slate-100 text-[9px] font-bold text-slate-400 uppercase tracking-widest">
        © {new Date().getFullYear()} WealthOS. All Rights Reserved.
      </p>
    </div>
  </footer>
);

export default Footer;